import { Button, CircularProgress, Modal, ModalDialog, Stack, Typography } from '@mui/joy';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Fragment } from 'react';

import { ModalCardHeader } from '@/components/modals/ModalCardHeader';
import { ModalMainButtonGroup } from '@/components/modals/ModalMainButtonGroup';
import { UserRegistrationForm } from '@/components/user-registration/UserRegistrationForm';
import { UserWaitingForApproval } from '@/components/user-registration/UserWaitingForApproval';
import { UserGuard } from '@/modules/UserGuard';
import { UserStatus } from '@/modules/api';
import { useUserSuspenseQuery } from '@/queries/useUserSuspenseQuery';

export const Route = createFileRoute('/_public/registrierung')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { data: user, isLoading } = useUserSuspenseQuery();

  if (UserGuard.isUser(user) && user.status === UserStatus.ACTIVE) {
    return <Navigate to="/verwaltung" />;
  }

  return (
    <Modal
      open
      onClose={() => {
        navigate({ to: '/' });
      }}
    >
      <ModalDialog maxWidth="sm" minWidth="sm">
        <ModalCardHeader title={UserGuard.isUser(user) ? 'Benutzerstatus' : 'Registrierung'} />

        {isLoading ? (
          <Stack alignItems="center">
            <CircularProgress />
          </Stack>
        ) : null}

        {!isLoading && !user && (
          <Fragment>
            <Typography level="title-lg">Login mit Service-BW</Typography>
            <Typography>
              Um Ihre Registrierung zu starten, müssen Sie sich via Service-BW anmelden. Bitte benutzen Sie Ihre
              amtliche E-Mail.
            </Typography>

            <ModalMainButtonGroup marginTop={4}>
              <Button
                fullWidth
                component="a"
                href={`/api/authentication/login?relayState=${encodeURIComponent('/registrierung')}`}
              >
                Login
              </Button>
            </ModalMainButtonGroup>
          </Fragment>
        )}

        {UserGuard.isSingleSignOnUser(user) && <UserRegistrationForm singleSignOnUser={user} />}

        {UserGuard.isUser(user) && <UserWaitingForApproval user={user} />}
      </ModalDialog>
    </Modal>
  );
}
